import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { withRouter } from 'react-router-dom';

import {
  UPDATE_ITEM,
  COMPLETE_REQUIRED_INFO_ABOVE
} from 'menus/constants/ctaName';
import { CART_ITEM } from 'cart/constants/paths';

import MobileFooter from 'base/components/MobileFooter';
import PrimaryCta from 'base/components/PrimaryCta';
import { getIsEnabledAddToCartSelector } from 'menus/selectors';
import MenuItemSubmitContainer from './MenuItemSubmitContainer';

class MenuItemPageFooter extends React.PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
    match: PropTypes.object,
    requiredFieldsAreSelected: PropTypes.bool,
    canAddToCart: PropTypes.bool
  };

  renderEditItemCTA = () => {
    const { dispatch, requiredFieldsAreSelected, canAddToCart } = this.props;

    return (
      <MobileFooter>
        <PrimaryCta
          disabled={!canAddToCart}
          handleClick={() => dispatch(submit('menuItemDetail'))}
          data-testname="update-item-button"
          fullWidth
          label={
            !requiredFieldsAreSelected
              ? UPDATE_ITEM
              : COMPLETE_REQUIRED_INFO_ABOVE
          }
        />
      </MobileFooter>
    );
  };

  render() {
    const { dispatch, match } = this.props;

    if (match.path === CART_ITEM) {
      return this.renderEditItemCTA();
    }

    return (
      <MobileFooter>
        <MenuItemSubmitContainer
          handleClick={() => dispatch(submit('menuItemDetail'))}
        />
      </MobileFooter>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...getIsEnabledAddToCartSelector(state),
    isAddingToCart: state.cart.isFetching,
    inventoryPreview: state.productPreview.inventory_preview,
    isUpdatingPreview: state.productPreview.isFetching,
    cartErrors: state.cart.error,
    inventory: state.productPreview.inventory
  };
};

export default withRouter(connect(mapStateToProps)(MenuItemPageFooter));
